module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('vue-waterfall-easy', {
    attrs: {
      "imgsArr": _vm.imgsArr
    },
    on: {
      "scrollLoadImg": _vm.fetchImgsData
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'canvas-gsh',
              params: {
                md5: props.value.md5
              }
            }
          }
        }, [_c('p', {
          staticClass: "some-info"
        }, [_vm._v(_vm._s(props.value.info))])])]
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47b49129","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Waterfall.vue
// module id = 191
// module chunks = 1